<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.quote.create_a_collection' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="jobcard-label">{{ 'bikeshop.modal.update_job_card.quote.name' | translate }}</div>
    <div class="input-control">
        <hub-input [placeholder]="'bikeshop.workshop.jobcard.quote.collection_examples' | translate" [autofocus]="true"
            [(ngModel)]="collectionName" [required]="true"></hub-input>
    </div>
    <div class="red" *ngIf="errorMessage">{{ errorMessage }}</div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'bikeshop.workshop.jobcard.quote.create_a_collection' | translate" [style]="'secondary'" [disabled]="!collectionName || saving"
            [size]="'xl'" (buttonClick)="createCollection()"></hub-button>
    </div>
    <div class="short-cut-container">
        <span><daz-icon [name]="'enter'" [size]="'18px'" [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' | translate}}
    </div>
</div>